import { Link } from '@tanstack/react-router';
import { Menu01 } from '@untitled-ui/icons-react';
import { twMerge } from 'tailwind-merge';

import { Blym } from './decorations/blym';

type MobileHeaderProps = {
  onMenuClick: () => void;
  className?: string;
};

export function MobileHeader(props: MobileHeaderProps) {
  const { onMenuClick, className } = props;

  return (
    <header
      className={twMerge(
        'fixed left-0 right-0 top-0 z-40 flex h-16 items-center justify-between bg-white px-4',
        className
      )}
    >
      <button
        onClick={onMenuClick}
        className="flex h-10 w-10 items-center justify-center rounded-lg text-branding-accent-600 hover:bg-branding-gray-100 active:bg-branding-gray-200"
        aria-label="Open menu"
      >
        <Menu01 width={24} height={24} />
      </button>

      <Link to="/app">
        <Blym width={90} />
      </Link>
    </header>
  );
}
